import { Controller } from "@hotwired/stimulus"

// Swap the unit label when a food is switched between weight and volume.
//
// The figures on a food are "per 100" of something, and which something is
// the one question that decides everything downstream — enter a sauce's
// per-100mL panel as per-100g and every number after it is wrong by the
// food's density, silently.
//
// So the label is not decoration: it is the form telling you which basis it
// is about to store, and it has to keep up with the radio rather than
// waiting for a save.
export default class extends Controller {
  static targets = ["unit", "word"]

  change(event) {
    this.render(event.target.value)
  }

  connect() {
    // A dialog reopened after a previous use keeps whatever was chosen last
    // time, so the label is caught up on connect rather than only on change.
    const checked = this.element.querySelector("input[name*='measured_in']:checked")

    if (checked) this.render(checked.value)
  }

  render(measure) {
    const volume = measure === "volume"

    // "mL" rather than "ml": the litre is capitalised after a person's name,
    // and a lowercase l next to a 1 is a genuine misread on a small label.
    // Food#base_unit_label spells it the same way server-side.
    const unit = volume ? "mL" : "g"

    this.unitTargets.forEach((target) => { target.textContent = unit })

    // A SYMBOL IS NOT ALWAYS THE RIGHT WORD. "Grams always works without
    // this" cannot be written with a "g", and it starts a sentence, so the
    // two spellings ride on the element rather than being derived here —
    // this controller has no business knowing English sentence case.
    this.wordTargets.forEach((target) => {
      target.textContent = volume
        ? target.dataset.unitVolume
        : target.dataset.unitWeight
    })

    // The unit rows are not labels and cannot be handled here: switching
    // measure changes WHICH units are offered — ml and litre against g and
    // kg — not merely how they are spelled. Each unit-picker owns its own
    // list, and there is one per row, so this announces the change and they
    // filter themselves.
    this.dispatch("changed", { detail: { measure }, prefix: "measure" })
  }
}
